<template>
    <div class="px-6">
        <paginator data-url="/customer/orders/list" v-slot:default="props">
            <div class="flex flex-col">
                <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                    <div class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                        <table class="min-w-full">
                            <thead>
                            <tr class="whitespace-no-wrap">
                                <th class="w-px px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                    #
                                </th>
                                <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                    Total
                                </th>
                                <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                    Fulfilment Status
                                </th>
                                <th class="w-px px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                    Last Updated
                                </th>
                                <th class="px-6 py-3 bg-gray-50"></th>
                            </tr>
                            </thead>
                            <tbody class="bg-white">
                            <tr v-for="order in props.items">
                                <td class="px-6 py-4 whitespace-no-wrap border-t border-gray-200 text-sm leading-5 font-medium text-gray-900">
                                    {{ order.id }}
                                </td>
                                <td class="px-6 py-4 whitespace-no-wrap border-t border-gray-200 text-sm leading-5 text-gray-500">
                                    £{{ order.formatted_total_with_credit_applied }}
                                </td>
                                <td class="px-6 py-4 whitespace-no-wrap border-t border-gray-200 text-sm leading-5 text-gray-500">
                                    <badge color="red"
                                           v-if="order.status === 0"
                                    >
                                        Unfulfilled
                                    </badge>
                                    <badge color="green"
                                           v-if="order.status === 1"
                                    >
                                        Fulfilled
                                    </badge>
                                    <badge color="gray"
                                           v-if="order.status === 2"
                                    >
                                        Cancelled
                                    </badge>
                                </td>
                                <td class="px-6 py-4 whitespace-no-wrap border-t border-gray-200 text-sm leading-5 text-gray-500">
                                    {{ order.last_updated }}
                                </td>
                                <td class="px-6 py-4 whitespace-no-wrap text-right border-t border-gray-200 text-sm leading-5 font-medium">
                                    <a :href="route('customer.order.show', order.id)" class="text-primary-600 hover:text-primary-700">
                                        View
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </paginator>
    </div>
</template>

<script>
    import Paginator from "../../../components/Paginator";
    import Badge from "../../../components/Badge";

    export default {
        components: { Paginator, Badge},
    }
</script>
